import { React, createContext, useState } from 'react'

export const WorkEthicsContext = createContext(null)
export const WorkEthicsProvider = ({ children }) => {
  const [workArea, setWorkArea] = useState('')
  const [device, setDevice] = useState('')
  const [fixSchedule, setFixSchedule] = useState('')
  const [shift, setShift] = useState('')
  const [jobHours, setJobHours] = useState('')
  const [timeTracker, setTimeTracker] = useState('')
  const [attachment, setAttachment] = useState('')
  const [ooklaLink, setOoklaLink] = useState('')
  const [ooklaScreenshot, setOoklaScreenshot] = useState(null)
  const [backupCPUScreenshot, setBackupCPUScreenshot] = useState(null)
  const [backupMonitorScreenshot, setBackupMonitorScreenshot] = useState(null)
  const [downloadSpeed, setDownloadSpeed] = useState('')
  const [uploadSpeed, setUploadSpeed] = useState('')
  const [ping, setPing] = useState('')

  return (
    <WorkEthicsContext.Provider
      value={{
        workArea,
        setWorkArea,
        device,
        setDevice,
        fixSchedule,
        setFixSchedule,
        shift,
        setShift,
        jobHours,
        setJobHours,
        timeTracker,
        setTimeTracker,
        attachment,
        setAttachment,
        ooklaLink,
        setOoklaLink,
        ooklaScreenshot,
        setOoklaScreenshot,
        backupCPUScreenshot,
        setBackupCPUScreenshot,
        backupMonitorScreenshot,
        setBackupMonitorScreenshot,
        downloadSpeed,
        setDownloadSpeed,
        uploadSpeed,
        setUploadSpeed,
        ping,
        setPing
      }}
    >
      {children}
    </WorkEthicsContext.Provider>
  )
}
